module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABVElEQVQ4jaXVP0scQRjH8Y8RtrrgWSu4IXBvQfImwvmPFL6RkwTS5iqJ5VmZUoUEGxu7U4MiJGlSpbFIax0s1GJnj3HcXTf6g2WY5/nNd/4w+8yUamV4iz5e4zZ8N7jENxzgumb8PfUxxgbyinwecmMsNYGmMcQ2XraYuBO8wzD2gYb40AKU6j0+pcFlfHkCrNQIK2Unww90nwHs4ieyabzDXxwlpi38wVUS7+EjDqPYP8xiHnbxqmLWHs5DG8fOklipHHvwvWErMaBqglSncNxgiFf6GAyOXzxiiHXbwpPBSYMh3mbT+ZW6oDjIvAaWAprOMcc+rCv+zVSbNQN7+FwR3wisycWeqTC1VRe/AgusYucZwFFgTKrEb7zBoqIs/Y8God1KE3H56rQAdcLKastXqWXFKgdYqMgvhNw4eO9pqgaaYU1RkeeiWPkEfFVctwdPwB17qEFKabTzEQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/new/icon-close.png
// module id = 911
// module chunks = 0